// Detect mobile devices
window.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || false;

if (cfg.page === "static_pages.index") {

	// When DOM is fully loaded
	jQuery(function($) {

		const headerHeight = $('.navbar').height();
		const sliderHeight = $(window).height() - 96;

		$('.homepage-carousel .slider-item').css('height', sliderHeight);

		// Initialize header carousel
		if ($('.homepage-carousel').length) {
			return $('.homepage-carousel').slick({
				autoplay: true,
				autoplaySpeed: 5000,
				draggable: true,
				touchMove: true,
				dots: false,
				fade: true,
				speed: 600,
				arrows: true
			});
		}
	});
}
